// extracted by mini-css-extract-plugin
module.exports = {"strava":"styles-module--strava--Gu9n9"};